(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tr-fall-announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tr-fall-announcement')) {
  customElements.define('tr-fall-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.epoch = null;
      this.monotonic = null;
      this.generation = 0;
      this.timer = null;
      this.abortController = new AbortController();
      this.start = Date.parse(this.dataset.start);
      this.end = Date.parse(this.dataset.end);
      customElements.whenDefined('slideshow-component').then(() => {
        if (!this.isConnected) return;
        this.slider = document.getElementById(this.dataset.sliderId);
        this.component = this.slider?.closest('slideshow-component');
        if (!this.component || typeof this.component.resetPages !== 'function') return;
        this.sale = this.querySelector('template').content.firstElementChild.cloneNode(true);
        const options = { signal: this.abortController.signal };
        document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') this.sync(); }, options);
        window.addEventListener('pageshow', () => this.sync(), options);
        this.sync();
      });
    }
    disconnectedCallback() {
      this.started = false;
      this.generation += 1;
      clearTimeout(this.timer);
      this.abortController?.abort();
    }
    setActive(active) {
      if (!this.sale || active === this.sale.isConnected) return;
      const focusWasInSale = this.sale.contains(document.activeElement);
      this.component.pause();
      clearTimeout(this.component.setPositionTimeout);
      if (active) this.slider.prepend(this.sale);
      else this.sale.remove();
      this.slider.scrollTo({ left: 0, behavior: 'instant' });
      this.component.resetPages();
      this.component.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      this.component.currentPage = 1;
      this.component.sliderItems.forEach((slide, index, items) => {
        slide.setAttribute('aria-label', `${index + 1} ${this.dataset.of} ${items.length}`);
      });
      this.component.setSlideVisibility();
      if (focusWasInSale) this.component.nextButton.focus({ preventScroll: true });
      if (this.slider.dataset.autoplay === 'true' && !this.component.reducedMotion.matches && !this.component.announcementBarArrowButtonWasClicked && !this.component.matches(':hover') && !this.component.contains(document.activeElement) && document.visibilityState === 'visible') this.component.play();
    }
    update() {
      clearTimeout(this.timer);
      if (this.epoch === null || this.monotonic === null) { this.setActive(false); return; }
      const now = this.epoch + performance.now() - this.monotonic;
      this.setActive(now >= this.start && now < this.end);
      if (now >= this.end) return;
      this.timer = setTimeout(() => this.update(), Math.min(60000, Math.max(1, (now < this.start ? this.start : this.end) - now)));
    }
    loseClock() {
      this.epoch = null;
      this.monotonic = null;
      this.update();
    }
    async sync() {
      const generation = ++this.generation;
      this.update();
      try {
        const separator = this.dataset.clockUrl.includes('?') ? '&' : '?';
        const response = await fetch(this.dataset.clockUrl + separator + 'tr_fall_bar_clock=' + Date.now(), { cache: 'no-store', credentials: 'same-origin', signal: this.abortController.signal });
        if (generation !== this.generation || !this.isConnected) return;
        const date = Date.parse(response.headers.get('Date') || '');
        const age = Number(response.headers.get('Age') || '0');
        if (!response.ok || !Number.isFinite(date) || !Number.isFinite(age) || age > 5) { this.loseClock(); return; }
        this.epoch = date + Math.max(0, age) * 1000;
        this.monotonic = performance.now();
        this.update();
      } catch (_) { if (generation === this.generation && this.isConnected) this.loseClock(); }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tr-fall-reset"] && !Shopify.designMode) return;
  try {
    (() => {
  const panel = document.getElementById('tr-fall-reset');
  if (!panel || typeof panel.showModal !== 'function') return;
  const start = Date.parse(panel.dataset.start);
  const end = Date.parse(panel.dataset.end);
  const seenKey = 'tr_fall_reset_seen_202609';
  try { if (localStorage.getItem(seenKey) === panel.dataset.end) return; } catch (_) { return; }
  const readyAt = performance.now() + 6000;
  let lastInteraction = 0;
  let serverEpoch = null;
  let monotonicEpoch = null;
  let timer = null;
  let generation = 0;
  let shown = false;
  let dismissed = false;
  function close() { if (panel.open) panel.close(); }
  function loseClock() { serverEpoch = null; monotonicEpoch = null; if (timer) clearTimeout(timer); close(); }
  function schedule(ms) { timer = setTimeout(update, Math.min(60000, Math.max(1, ms))); }
  function occupied() {
    const focused = document.activeElement;
    if (focused && focused.matches('input, textarea, select, [contenteditable="true"]')) return true;
    return Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], cart-drawer.active, menu-drawer details[open]')).some(el => {
      const style = getComputedStyle(el);
      return el !== panel && el.getClientRects().length > 0 && style.visibility !== 'hidden' && style.display !== 'none' && Number(style.opacity) > 0;
    });
  }
  function update() {
    if (timer) clearTimeout(timer);
    if (serverEpoch === null || monotonicEpoch === null) { close(); return; }
    const now = serverEpoch + performance.now() - monotonicEpoch;
    if (now >= end) { close(); return; }
    if (now < start) { close(); schedule(start - now); return; }
    if (dismissed) return;
    if (!shown) {
      if (document.visibilityState !== 'visible' || performance.now() < readyAt || performance.now() - lastInteraction < 1500 || occupied()) { schedule(Math.min(2000, end - now)); return; }
      try {
        if (localStorage.getItem(seenKey) === panel.dataset.end) return;
        localStorage.setItem(seenKey, panel.dataset.end);
        panel.showModal();
        shown = true;
        panel.querySelector('h2').focus({ preventScroll: true });
      } catch (_) { close(); return; }
    }
    schedule(end - now);
  }
  async function sync() {
    const requestGeneration = ++generation;
    update();
    try {
      const separator = panel.dataset.clockUrl.includes('?') ? '&' : '?';
      const response = await fetch(panel.dataset.clockUrl + separator + 'tr_fall_clock=' + Date.now(), { cache: 'no-store', credentials: 'same-origin' });
      if (requestGeneration !== generation) return;
      if (!response.ok) { loseClock(); return; }
      const date = Date.parse(response.headers.get('Date') || '');
      const age = Number(response.headers.get('Age') || '0');
      if (!Number.isFinite(date) || !Number.isFinite(age) || age > 5) { loseClock(); return; }
      serverEpoch = date + Math.max(0, age) * 1000;
      monotonicEpoch = performance.now();
      update();
    } catch (_) { if (requestGeneration === generation) loseClock(); }
  }
  panel.querySelectorAll('[data-fall-close], [data-fall-cta]').forEach(el => el.addEventListener('click', close));
  panel.addEventListener('close', () => { dismissed = true; if (timer) clearTimeout(timer); });
  panel.addEventListener('click', event => {
    if (event.target !== panel) return;
    const rect = panel.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  document.addEventListener('pointerdown', event => { if (!panel.contains(event.target)) lastInteraction = performance.now(); }, { passive: true });
  document.addEventListener('keydown', event => { if (!panel.contains(event.target)) lastInteraction = performance.now(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') sync(); });
  window.addEventListener('pageshow', sync);
  sync();
})();
  } catch(e) { console.error(e); }
})();

})();
